(() => {
  if (window.nwanProductTabsLoaded) return;
  window.nwanProductTabsLoaded = true;

  function importDescription(root) {
    const description = root.querySelector('[data-nwan-description]');
    if (!description) return;
    const headings = Array.from(description.children).filter((node) => /^H[2-6]$/.test(node.tagName));
    const sources = {
      specifications: ['product details', 'specifications'],
      fitment: ['vehicle compatibility', 'vehicle fitment', 'application'],
    };
    Object.keys(sources).forEach((key) => {
      const target = root.querySelector(`[data-nwan-import="${key}"]`);
      if (!target || target.hasAttribute('data-nwan-custom-content')) return;
      const fragments = headings.filter((heading) => sources[key].includes(heading.textContent.trim().toLowerCase()))
        .map((heading) => heading.nextElementSibling)
        .filter((node) => node && /^(UL|OL|P|TABLE|DL)$/.test(node.tagName) && node.textContent.trim());
      if (!fragments.length) return;
      // Only reuse explicit sections of the description; never infer fitment from a title.
      target.replaceChildren(...fragments.map((node) => {
        const copy = node.cloneNode(true);
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach((child) => child.removeAttribute('id'));
        return copy;
      }));
      target.dataset.nwanContentSource = 'description';
      if (key === 'fitment') {
        Array.from(description.children).filter((node) => node.tagName === 'P' &&
          node.querySelector('strong')?.textContent.trim().toLowerCase() === 'installation / fitment note:')
          .forEach((node) => {
            const copy = node.cloneNode(true);
            copy.removeAttribute('id');
            copy.querySelectorAll('[id]').forEach((child) => child.removeAttribute('id'));
            target.append(copy);
          });
      }
    });
  }

  function init(root) {
    if (root.dataset.nwanTabsReady) return;
    const nav = root.querySelector('.nwan-product-tabs__nav');
    const tabs = Array.from(root.querySelectorAll('[data-nwan-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-nwan-panel]'));
    if (!nav || !tabs.length || tabs.some((tab) => !panels.some((panel) => panel.dataset.nwanPanel === tab.dataset.nwanTab))) return;
    importDescription(root);
    root.dataset.nwanTabsReady = 'true';
    const controller = new AbortController();
    root.addEventListener('nwan:tabs:unload', () => controller.abort(), { once: true });
    nav.setAttribute('role', 'tablist');

    function select(key, focus) {
      tabs.forEach((tab) => {
        const active = tab.dataset.nwanTab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) {
          tab.focus({ preventScroll: true });
          tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
      panels.forEach((panel) => { panel.hidden = panel.dataset.nwanPanel !== key; });
    }

    tabs.forEach((tab, index) => {
      const panel = panels.find((item) => item.dataset.nwanPanel === tab.dataset.nwanTab);
      tab.id = `${panel.id}-tab`;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      panel.tabIndex = 0;
      tab.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        event.preventDefault();
        select(tab.dataset.nwanTab, false);
      });
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (event.key === ' ') next = index;
        if (next === undefined) return;
        event.preventDefault();
        select(tabs[next].dataset.nwanTab, true);
      });
    });

    function openHash() {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { return; }
      if (!id) return;
      const panel = panels.find((item) => item.id === id || Array.from(item.querySelectorAll('[id]')).some((node) => node.id === id));
      const legacy = { 'nwan-product-overview': 'overview', 'nwan-product-specifications': 'specifications', 'nwan-product-fitment': 'fitment' };
      const key = panel?.dataset.nwanPanel || legacy[id];
      if (key) select(key, false);
    }

    // Open the hidden reviews panel before a rating-summary anchor scrolls to it.
    const page = root.closest('.nwan-product-page') || root;
    page.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link || link.hasAttribute('data-nwan-tab')) return;
      const id = link.getAttribute('href').slice(1);
      const panel = panels.find((item) => item.id === id || Array.from(item.querySelectorAll('[id]')).some((node) => node.id === id));
      if (panel) select(panel.dataset.nwanPanel, false);
    }, { signal: controller.signal });
    window.addEventListener('hashchange', openHash, { signal: controller.signal });
    select('overview', false);
    openHash();
  }

  function scan() {
    document.querySelectorAll('[data-nwan-tabs]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-nwan-tabs]').forEach((root) => {
      // Hash listeners must not retain detached theme-editor sections.
      root.dispatchEvent(new CustomEvent('nwan:tabs:unload'));
    });
  });
})();
